/**
 * @owner @Appboy/in-app-messages
 */

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const submittedSurveyCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("submitted_survey_campaign_filter"),
  comparison_key: z.enum(["7", "8"]),
  display_name: z.string(),
  raw_value: common.objectId.optional(),
  value: z.object({
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
